import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Dropdown, Grid } from 'semantic-ui-react';

import { Icon, RecordsTable, SearchBar } from 'dyl-components';
import AddCampaignRegistrationModal from './subcomponents/AddCampaignRegistrationModal';
import { useDispatch, useSelector } from 'react-redux';
import tcrConfig from "actions/tcr"
import CampaignRegistrationHeader from './subcomponents/Header';
import CampaignRegistrationRow from './subcomponents/Row';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS } from 'dyl-components';

export default function CampaignRegistration() {
  const [params] = useSearchParams();
  const [search, setSearch] = useState(params.get('search') || '');
  const navigate = useNavigate();
  const route_root = `/settings/phone-management/tcr/campaign-registration`;
  const { tcr_details, isReadingTcrDetails } = useSelector((state) => state.subscription)

  const canCreateHighVolumeCampaign = !!tcr_details?.high_volume_campaign_subscription_id;
  const canCreateLowVolumeCampaign = !!tcr_details?.low_volume_campaign_subscription_id;

  const { brand_campaign } = useSelector(state => state.tcr);

  const DROPDOWN = [
    { 
      key: "High Volume Campaign", 
      value: "High Volume Campaign", 
      text: "High Volume Campaign", 
      disabled: (isReadingTcrDetails || !canCreateHighVolumeCampaign), 
      content: (
        <span>
          <Icon className="fas fa-arrow-up" color="primary" /> High
          Volume Campaign
        </span>
      ),
      onClick: () => {
        if (!isReadingTcrDetails && canCreateHighVolumeCampaign) {
          setIsModalOpen({
            isOpen: true,
            type: "high_volume"
          });
        }
      },
      userPermission: USER_PERMISSIONS.CAMPAIGN_REGISTRATION_ADD
    },
    { 
      key: "Low Volume Campaign", 
      value: "Low Volume Campaign", 
      text: "Low Volume Campaign", 
      disabled: (isReadingTcrDetails || !canCreateLowVolumeCampaign),
        content: (
          <span>
            <Icon className="fas fa-arrow-down" color="primary" /> Low
            Volume Campaign
          </span>
        ),
        onClick: () => {
          if (!isReadingTcrDetails && canCreateLowVolumeCampaign) {
            setIsModalOpen({
              isOpen: true,
              type: "low_volume"
            });
          }
        },
      userPermission: USER_PERMISSIONS.CAMPAIGN_REGISTRATION_ADD
    },
  ]

  const [isModalOpen, setIsModalOpen] = useState({
    isOpen: false,
    type: null
  });
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [filters, setFilters] = useState({
    created: params.get('created')?.split(','),
    registration_on: params.get('registration_on')?.split(','),
    auto_renewal_on: params.get('auto_renewal_on')?.split(','),
    approval_status: params.get('approval_status')?.split(','),
    tcr_status: params.get('tcr_status')?.split(','),
  })
  const onChangeSearch = (_, { value }) => {
    setSearch(value);
  }
  const cancelFunction = () => {
    setSearch("");
    const query = new URLSearchParams(params);
    query.delete('search');
    const query_string = query.toString();
    navigate(`${route_root}${query_string ? `?${query_string}` : ''}`);
  }
  const onSearchSubmit = (value) => {
    const query = new URLSearchParams(params);
    query.set('search', value.trim());
    query.set('page', 1);
    const query_string = query.toString();
    navigate(`${route_root}${query_string ? `?${query_string}` : ''}`);
  }
  const onFilter = async (_, { name, value }) => {
    setFilters({
      ...filters,
      [name]: value
    });
  }
  const onPageChange = (_, { activePage }) => {
    const query = new URLSearchParams(params);
    query.set('page', activePage);
    const query_string = query.toString();
    navigate(`${route_root}${query_string ? `?${query_string}` : ''}`);
  }
  const dispatch = useDispatch();
  const { isReadingBrandCampaigns, brand_campaigns_count, brand_campaigns } = useSelector(state => state.tcr);
  const LIMIT =12;
  useEffect(() => {
    const query = new URLSearchParams(params);
    const page = query.get('page') || 1;
    const approval_status = query.get('approval_status')?.split(',') || [];
    const tcr_status = query.get('tcr_status')?.split(',') || [];
    const order = query.get('order') || '';
    const order_by = query.get('order_by') || '';
    const created_start = query.get('created_start') || '';
    const created_end = query.get('created_end') || '';
    const registered_start = query.get('registered_start') || '';
    const registered_end = query.get('registered_end') || '';
    const auto_renewal_start = query.get('auto_renewal_start') || '';
    const auto_renewal_end = query.get('auto_renewal_end') || '';
    const search = query.get('search') || '';

    dispatch(tcrConfig.getBrandCampaigns({ limit:LIMIT, page, status: approval_status, tcr_status, order, order_by, created_start, created_end, registered_start, registered_end, auto_renewal_start, auto_renewal_end, search }));
  }, [dispatch, params])
  useEffect(() => {
    const query = new URLSearchParams(params);

    if (search.trim()) {
      query.set('search', search);
    } else {
      query.delete('search');
    }
    const { approval_status, tcr_status } = filters;
    if (approval_status?.length > 0) {
      query.set('approval_status', approval_status.join(','));
    } else {
      query.delete('approval_status');
    }
    if (tcr_status?.length > 0) {
      query.set('tcr_status', tcr_status.join(','));
    } else {
      query.delete('tcr_status');
    }

    const { filter } = filters;
    if (filter?.length > 0) {
      query.set('filter', filter);
    } else {
      query.delete('filter');
    }

    const query_string = query.toString();
    navigate(`/settings/phone-management/tcr/campaign-registration${query_string ? `?${query_string}` : ''}`,);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  useEffect(() => {
    dispatch(tcrConfig.getBrand());
  }, [dispatch])
  return (
    <div className='CampaignRegistration'>
      <div className='CampaignRegistrationToolbar'>
        <div style={{ flex: 1 }}>
          <SearchBar
            isSearching={false}
            search={search}
            onChange={onChangeSearch}
            searchFcn={onSearchSubmit}
            cancelFcn={cancelFunction}
            placeholder={'Search by Name'}
            addClassNames='CampaignRegistration__search'
            bottomError
          />
        </div>
        <div>
          <Dropdown
            as={Button}
            floated="right"
            floating
            pointing="top left"
            disabled={(isReadingTcrDetails || (!canCreateHighVolumeCampaign && !canCreateLowVolumeCampaign))} //
            text={
              <span>
                <Icon className="fas fa-plus" /> New
                TCR Campaign
              </span>
            }
            className="AddTCRCampaignButton"
            selectOnBlur={false}
            value={null}
          >
            <Dropdown.Menu>
                  {DROPDOWN.map(item => (
                      <RestrictedView type="disabled" userPermission={item.userPermission}>
                          <Dropdown.Item onClick={item.onClick} disabled={item.disabled} selected={false}>
                              {item.content}
                          </Dropdown.Item>
                      </RestrictedView>
                  ))}
              </Dropdown.Menu>
          </Dropdown>  
        </div>
      </div>
      <Grid.Row>
        <Grid.Column>
          <RecordsTable
            isTableLoading={isReadingBrandCampaigns}
            isSearchResultEmpty={brand_campaigns_count === 0 && (params.get('search') || params.get('registration_on') || params.get('start') || params.get('end') || params.get('auto_renewal_on') || params.get('owned_by') || params.get('approval_status') || params.get('tcr_status'))}
            isTableEmpty={brand_campaigns_count === 0 && !(params.get('search') || params.get('registration_on') || params.get('start') || params.get('end') || params.get('auto_renewal_on') || params.get('owned_by') || params.get('approval_status') || params.get('tcr_status'))}
            TableHeader={<CampaignRegistrationHeader onFilter={onFilter} />}
            TableRows={brand_campaigns.map(campaign => (
              <CampaignRegistrationRow
                key={campaign?.id}
                campaign={campaign}
                onRowClick={()=>{
                  setIsEditOpen(true);
                }}
              />
            ))}
            recordsCount={brand_campaigns_count}
            activePage={params.get('page')}
            onPageChange={onPageChange}
            recordsName='Campaign'
            emptySubtitle=""
            emptyListTitle="No TCR Campaign Added."
            emptySubtitleHidden
            noBorder
            recordsLimit={LIMIT}

          />
        </Grid.Column>
      </Grid.Row>
      <AddCampaignRegistrationModal open={isModalOpen.isOpen || isEditOpen} campaign={isEditOpen ? brand_campaign : null} onClose={() => { setIsModalOpen({ isOpen: false, type: null }); setIsEditOpen(false) }} type={isEditOpen? brand_campaign?.high ? "high_volume" : "low_volume": isModalOpen.type} />
    </div>
  )
}
